import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { Loader } from "components";
import { Policy } from "types";
import SignIn from "pages/SignIn";
import { signIn, selectToken, selectStatus } from "./authSlice";

interface AuthProps extends React.PropsWithChildren {}
type SavedPolicy = Policy | undefined;

const Auth: React.FC<AuthProps> = ({ children }) => {
  const [policy, setPolicy] = useLocalStorage<SavedPolicy>("policy", undefined);
  const [params, setParams] = useSearchParams();
  const token = useSelector(selectToken);
  const status = useSelector(selectStatus);
  const dispatch = useDispatch<any>();
  const code = params.get("code");

  useEffect(() => {
    let ignore = false;

    if (code && status === "idle" && !ignore) {
      dispatch(signIn({ code, policy }));
    }

    return () => {
      ignore = true;
    };
  }, [code, status, policy, dispatch]);

  useEffect(() => {
    if (token && code) {
      setParams("", { replace: true });
    }
  }, [token, code, setParams]);

  return (
    <>
      {status === "loading" && <Loader />}
      {token ? children : <SignIn onPolicyChange={setPolicy} />}
    </>
  );
};

export default Auth;
